
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/live",
      function () {
        return require("private-next-pages/play/live.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/live"])
      });
    }
  